module.exports = __webpack_public_path__ + "img/collection-weddingRingstrisets@2x.224ce15.webp";